export default __webpack_public_path__ + "static/media/scaleRulerIcon.ef1bf989.svg";